<template>
  <div class="resolved-page">
    <div class="resolved-center">
      <div class="resolved-icon">
        <font-awesome-icon icon="check" class="check"></font-awesome-icon>
      </div>

      <div class="resolved-title">Ticket Resolved</div>
      <div class="resolved-subtitle">
        The ticket has been closed. Thank you for<br />
        your feed back
      </div>
    </div>
    <div class="resolved-actions">
      <b-button block variant="custom-primary" @click="goBack">
        Go back To ticket list
      </b-button>
      <b-button
        variant="custom-outline-primary"
        class="w-100 mt-3"
        @click="reOpen"
      >
        Re-Open Ticket
      </b-button>
    </div>
  </div>
</template>

<script>
export default {
  name: "TicketResolved",
  props: {
    reopenDisabled: { type: Boolean, default: true },
  },
  methods: {
    goBack() {
      window.parent.postMessage("onCancelModal", this.$parentOrigin);
      this.$router.replace("/customer/ticket");
    },
    reOpen() {
      this.updateActivityByAction();
    },
    async updateActivityByAction(actionType) {
      this.$bus.$emit("showLoading");
      const tickets = [
        {
          ticket_id: this.$route.params.ticketId,
          ticket_form_id: 1,
        },
      ];
      const payload = {
        tickets: tickets,
        assignTo: "",
        action_type: 4,
      };

      const { data } = await this.axios.post(`/ticket/action`, payload);

      this.$bus.$emit("hideLoading");
      if (data.result == 1) {
        this.successAlert().then(() => {
          this.$router.replace(
            `/customer/ticket/${this.$route.params.ticketId}`,
          );
        });
      } else {
        this.errorAlert(data.message);
      }
    },
  },
};
</script>

<style scoped>
.resolved-page {
  min-height: 100vh;
  background: #ffffff;
  position: relative;
  padding: 24px 18px 140px;
}

.resolved-center {
  height: calc(100vh - 140px);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  gap: 14px;
}

.resolved-icon {
  width: 120px;
  height: 120px;
  border-radius: 999px;
  background: #7b2bd4;
  display: grid;
  place-items: center;
}

.resolved-icon .check {
  color: #fff;
  font-size: 64px;
  font-weight: 800;
  line-height: 1;
  transform: translateY(-2px);
}

.resolved-title {
  font-size: 22px;
  font-weight: 800;
  color: #111;
  margin-top: 6px;
}

.resolved-subtitle {
  font-size: 14px;
  color: #5f6368;
  line-height: 1.45;
}

.resolved-actions {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  padding: 10px 14px 18px;
  background: #fff;
  /* border-top: 1px solid #eee; */
}

.btn-primary-solid {
  background: #7b2bd4 !important;
  border-color: #7b2bd4 !important;
  font-weight: 700;
  height: 46px;
  border-radius: 8px;
  margin-bottom: 10px;
}

.btn-outline-soft {
  background: #fff !important;
  border: 2px solid #d9d9d9 !important;
  color: #9aa0a6 !important;
  font-weight: 700;
  height: 46px;
  border-radius: 8px;
}

.btn-outline-soft:disabled {
  opacity: 1;
}
</style>
